import React from 'react'
import Button from './Button'
import Test from './Test'
import ContentList from './ContentList'
import PostList from './PostList'

export const Q_CONTENTS = 'q_latest-posts'

export default class Home extends React.Component {
  state = {
    value: Date.now()
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    return null
  }
  componentDidMount() {
  }
  render() {
    return (
      <div className="container">
        <h1>Home</h1>
        <div className="container">
          <ContentList
            className="card-deck"
            name={Q_CONTENTS}
          />
        </div>
        {
          false&&
          <div>
            <PostList

            />
          </div>
        }
        {
          false&&
          <div>
            <Button
              className="btn btn-primary"
              label="test"
              onClick={(event)=>{
                this.setState({value:Date.now()})
              }}
            />
            <Test value={this.state.value} />
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js